<template>
  <form v-form class="form-inline">
    <div class="table-responsive">
      <table class="table table-bordered" v-table:info v-cols="[40, 60]">
        <tbody>
          <tr>
            <th v-req>試験問題コード</th>
            <td>
              <input-text v-model="examFormGroupCode" :error="$error('examFormGroupCode')"/>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button v-button:cancel @click="close" />
        <button v-button:save @click="save" :disabled="processing"/>
      </div>
    </div>
  </form>
</template>

<script>
import {Service} from "./_resource";
import {announce} from "@/calico-vue/announce/announce";

export default {
  data() {
    return {
      examFormGroupCode: null,
      processing: false
    };
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    save() {
      this.processing = true;
      Service.addExamFormGroup(this.examFormGroupCode).then(() => {
        announce.saved();
        this.$emit('close', true);
      }).catch(error => {
        this.error = error;
        this.processing = false;
      });
    }
  }
};
</script>
